import { CommonModule } from '@angular/common';
import { Injector, NgModule } from '@angular/core';
import { WidgetRegistryService } from '@common-modules/widget-registry/widget-registry';
import { WLMGridModule } from '@common-modules/wlm-grid/wlm-grid.module';
import { CtTypeAttributeGridComponent } from './components/ct-type-attribute-grid/ct-type-attribute-grid.component';
import { CtMapModule } from './ct-map.module';
import { CTLayerItemService } from './services/ct-layer-item.service';
import { CTMapBuilderService } from './services/ct-map-builder.service';
import { CTResultsFormatService } from './services/ct-results-format.service';
import { CTSyncMapGridService } from './services/ct-sync-map-grid.service';
import { CtMapGridContainerWidgetComponent } from './widgets/ct-map-grid-container-widget/ct-map-grid-container-widget.component';
import { CtMapWidgetComponent } from './widgets/ct-map-widget/ct-map-widget.component';
import { CtTypeAttributeGridWidgetComponent } from './widgets/ct-type-attribute-grid-widget/ct-type-attribute-grid-widget.component';

@NgModule({
  declarations: [CtTypeAttributeGridComponent, CtTypeAttributeGridWidgetComponent],
  imports: [CommonModule, WLMGridModule],
  providers: [
    CTLayerItemService,
    CTResultsFormatService,
    CTMapBuilderService,
    CTSyncMapGridService,
  ],
  exports: [CtTypeAttributeGridWidgetComponent, CtTypeAttributeGridComponent],
})
export class CtMapSharedModule {
  static injector: Injector;
  constructor(injector: Injector, private _widgetRegistry: WidgetRegistryService) {
    CtMapModule.injector = injector;
    this._widgetRegistry.register([
      {
        name: 'CtMapWidgetComponent',
        widgetClass: CtMapWidgetComponent,
      },
      {
        name: 'CtMapGridContainerWidgetComponent',
        widgetClass: CtMapGridContainerWidgetComponent,
      },
      {
        name: 'CtTypeAttributeGridWidgetComponent',
        widgetClass: CtTypeAttributeGridWidgetComponent,
      },
    ]);
  }
}
